import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18n-js'

import Input from '../../UI/Input/Input'
import EHPResult from '../EHPResult/EHPResult'
import SearchForm from './SearchForm/SearchForm'

import './DepthForm.scss'

const DepthForm = props => {

    const monsters = useSelector(state => state.monsters)
    const defaultMonster = monsters.find(el => el.name === 'Baleygr')
    const [currentMonster, setCurrentMonster] = useState(defaultMonster)
    const parsedName = currentMonster['name'].toLowerCase().replaceAll(' ', '_')
    const [showSearchForm, setShowSearchForm] = useState(false)

    const [HPInput, setHPInput] = useState({
        type: 'tel',
        id: 'hp',
        value: 0,
        label: i18n.t('hp_label'),
        maxLength: 5,
        hideLabel: true
    })

    const [defInput, setDefInput] = useState({
        type: 'tel',
        id: 'def',
        value: 0,
        label: i18n.t('defense_label'),
        maxLength: 5,
        hideLabel: true
    })

    const [resultData, setResultData] = useState({
        baseHP: currentMonster.hp,
        HP: currentMonster.hp,
        runesHP: 0,
        baseDEF: currentMonster.def,
        DEF: currentMonster.def,
        runesDEF: 0
    })

    const updateForm = (evt, id) => {

        const val = parseInt(evt.target.value)

        if (id === 'hp') {
            setHPInput({
                ...HPInput,
                value: !!val ? val : 0
            })
            setResultData({
                ...resultData,
                HP: val > 0 ? val + currentMonster.hp : 1,
                runesHP: val
            })
        } else {
            setDefInput({
                ...defInput,
                value: !!val ? val : 0
            })
            setResultData({
                ...resultData,
                DEF: val > 0 ? val + currentMonster.def : 1,
                runesDEF: val
            })
        }
    }

    const updateMonster = name => {
        const newMonster = monsters.find(el => el.name === name)
        setCurrentMonster(newMonster)
        setShowSearchForm(false)
        setHPInput({
            ...HPInput,
            value: 0
        })
        setDefInput({
            ...defInput,
            value: 0
        })
        setResultData({
            HP: newMonster.hp,
            DEF: newMonster.def,
            baseHP: newMonster.hp,
            baseDEF: newMonster.def,
            runesDEF: 0,
            runesHP: 0
        })
    }

    // console.log('current', currentMonster)

    return <div className="DepthForm">
        {showSearchForm ? <SearchForm monsters={monsters}
            selected={name => updateMonster(name)}
            back={() => setShowSearchForm(false)} /> : <>
                <div className="col-md-6 mx-auto">
                    {currentMonster && <div className="title-wrapper">
                        <h2>{currentMonster.name}</h2>
                        <div className="img-wrapper" role="button" tabIndex="0" aria-label={i18n.t('change')} onClick={() => setShowSearchForm(true)}>
                            <img src={`https://mogget24.bitbucket.io/sw/icons/${parsedName}.png`} alt="" />
                            <p>{i18n.t('change')}</p>
                        </div>
                    </div>}
                </div>
                <div className="col-md-6 mx-auto">
                    <div className="my-3">
                        <div className="row-with-input">
                            <p>{i18n.t('base_hp')}</p>
                            <p>{i18n.t('runes_stats')}</p>
                            <p>{i18n.t('total')}</p>
                        </div>
                        <div className="row-with-input">
                            <div>{currentMonster.hp}</div>
                            <div className="input-wrapper">
                                <span className="plus-icon">+</span>
                                <Input key={HPInput.id} {...HPInput} changed={evt => updateForm(evt, 'hp')} />
                            </div>
                            <div>{resultData.HP}</div>
                        </div>
                        <div className="row-with-input">
                            <div>{currentMonster.def}</div>
                            <div className="input-wrapper">
                                <span className="plus-icon">+</span>
                                <Input key={defInput.id} {...defInput} changed={evt => updateForm(evt, 'def')} />
                            </div>
                            <div>{resultData.DEF}</div>
                        </div>
                    </div>
                </div>
                <EHPResult {...resultData} />
                <button type="button" className="back-button" onClick={props.back}>{i18n.t('back')}</button>
            </>}
    </div>
}

export default DepthForm